export const environment = {
  production: `false`,
  launchcontrolAdminDomain: `demo-admin.dealerteamwork.com`,
  launchcontrolApiDomain: `demo-api.dealerteamwork.com`,
  autoDomain: `auto-api.demo-admin.dealerteamwork.com`,
  autoPort: `443`,
  mpopDomain: `adflex-api.demo-admin.dealerteamwork.com`,
  envName: `undefined`
};
